import React, { useMemo } from 'react';

interface AddVideoResponseProps {
  response: {
    video?: any;
  };
  label: string;
}

const AddVideoResponse: React.FC<AddVideoResponseProps> = ({ response }) => {
  const videoContent = useMemo(() => {
    return { __html: response.video };
  }, [response.video]);

  return (
    <div className="mb-4 max-w-screen-lg mx-auto aspect-w-16 aspect-h-9">
      <div className="video-container" dangerouslySetInnerHTML={videoContent} />
    </div>
  );
};

export default AddVideoResponse;
